/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$Outbound,
  AgentPolicySelector$outboundSchema,
} from "./agentpolicyselector.js";

/**
 * Grant effect; direct agent policy is allow-only
 */
export const CreateAgentPolicyGrantFormEffect = {
  Allow: "allow",
} as const;
/**
 * Grant effect; direct agent policy is allow-only
 */
export type CreateAgentPolicyGrantFormEffect = ClosedEnum<
  typeof CreateAgentPolicyGrantFormEffect
>;

export type CreateAgentPolicyGrantForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Grant effect; direct agent policy is allow-only
   */
  effect: CreateAgentPolicyGrantFormEffect;
  /**
   * Agent-runtime-safe scope to grant
   */
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export const CreateAgentPolicyGrantFormEffect$outboundSchema: z.ZodMiniEnum<
  typeof CreateAgentPolicyGrantFormEffect
> = z.enum(CreateAgentPolicyGrantFormEffect);

/** @internal */
export type CreateAgentPolicyGrantForm$Outbound = {
  agent_id: string;
  effect: string;
  scope: string;
  selector: AgentPolicySelector$Outbound;
};

/** @internal */
export const CreateAgentPolicyGrantForm$outboundSchema: z.ZodMiniType<
  CreateAgentPolicyGrantForm$Outbound,
  CreateAgentPolicyGrantForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    effect: CreateAgentPolicyGrantFormEffect$outboundSchema,
    scope: z.string(),
    selector: AgentPolicySelector$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
    });
  }),
);

export function createAgentPolicyGrantFormToJSON(
  createAgentPolicyGrantForm: CreateAgentPolicyGrantForm,
): string {
  return JSON.stringify(
    CreateAgentPolicyGrantForm$outboundSchema.parse(createAgentPolicyGrantForm),
  );
}
